<template>
  <div>
    <form class="filter-block__form" @submit.prevent="submit">
      <div class="filter-block__group">
        <button
          :disabled="disableSaveButton"
          class="bordered-btn blue-button"
          type="button"
          @click="onPriceRequestClick"
        >
          {{ $t("Price request") }}
        </button>
      </div>
      <!--suppress CheckEmptyScriptTag -->
      <field
        :errors="errors"
        :field="fields.get('location')"
        :model="model"
        layout="filter-block"
      />
      <field
        :key="radiusKey"
        :errors="errors"
        :field="fields.get('distance')"
        :model="model"
        layout="filter-block"
      />
      <field
        v-if="fields.get('features') && fields.get('features').options.length"
        :errors="errors"
        :field="fields.get('features')"
        :model="model"
        layout="filter-block"
      />
      <field
        v-if="
          fields.get('payment_method') &&
          fields.get('payment_method').options.length
        "
        :errors="errors"
        :field="fields.get('payment_method')"
        :model="model"
        layout="filter-block"
      />
      <field
        :key="priceKey"
        :errors="errors"
        :field="fields.get('price')"
        :model="model"
        layout="filter-block"
      />
      <field
        :errors="errors"
        :field="fields.get('rating')"
        :model="model"
        layout="filter-block"
      />
      <fields
        :errors="errors"
        :fields="
          fields.except(
            'location',
            'distance',
            'features',
            'payment_method',
            'price',
            'rating'
          )
        "
        :model="model"
        layout="filter-block"
      />
      <div class="filter-block__group">
        <div class="filter-block__text">
          {{ $t("Actions") }}
        </div>
        <button
          :disabled="disableSaveButton"
          class="bordered-btn blue-button mb-2"
          type="button"
          @click.prevent="
            lockSaveButton
              ? undefined /* do nothing */
              : $refs.searchTitleModal.show()
          "
        >
          {{ lockSaveButton ? $t("Already saved") : $t("Save Search") }}
        </button>
        <button
          v-if="model.category"
          :disabled="disableSaveButton"
          class="bordered-btn purple-button mb-2"
          type="button"
          @click="onBestAdButtonClickSubmit"
        >
          {{ $t("Auto-fit Best Ads") }}
        </button>
        <div class="filter-block__reset">
          <a href @click.prevent="reset">
            <!--suppress CheckEmptyScriptTag -->
            <i class="fas fa-redo" />
            {{ $t("Reset All") }}
          </a>
        </div>
      </div>
    </form>

    <best-add-modal ref="modal" @submit="onModalSubmit" />
    <form-modal ref="formModal" :fields="formFields" :model="model" />
    <search-title-modal
      ref="searchTitleModal"
      @submit="saveSearch"
    ></search-title-modal>
  </div>
</template>

<script>
import { FormMixin } from "stylemix-base";
import debounce from "lodash-es/debounce";
import fieldsHydrator from "../../components/hydrator";
import qs from "qs";

import BestAddModal from "./../BestAddModal.vue";
import SearchTitleModal from "./../SearchTitleModal.vue";
import FormModal from "./../FormModal.vue";

export default {
  name: "FilterBlock",

  components: {
    BestAddModal,
    SearchTitleModal,
    FormModal,
  },

  mixins: [FormMixin],

  props: {
    initialData: {
      type: [Object, Array],
      default: () => {},
    },
    disableSaveButton: Boolean,
    lockSaveButton: Boolean,
  },

  data: () => {
    return {
      model: {
        payment_method: [],
      },
      formFields: [],
    };
  },
  computed: {
    priceKey() {
      return this.$store.getters.getKey("price");
    },
    radiusKey() {
      return this.$store.getters.getKey("radius");
    },
  },

  created() {
    this.$http
      .get("updateFormCategory/" + this.$route.params.id, {})
      .then((response) => {
        window.FORM = response.data;
        this.$set(this, "formFields", response.data);
      });
  },
  mounted() {},
  methods: {
    setOnLoadData() {
      let search = window.location.search.replace(/\?/, "");
      let query = qs.parse(search);
      let params = this.$store.getters.getParameters;

      if (query) {
        for (let key in query) {
          if (!query.hasOwnProperty(key)) continue;
          switch (true) {
            case params.hasOwnProperty(key):
              this.$store.commit("setParameter", {
                name: key,
                value: this.isNumeric(query[key])
                  ? Number(query[key])
                  : query[key],
              });
              break;
            case key === "rating" && query[key] === "":
              this.$set(this.model, key, 0);
              break;
            case this.isNumeric(query[key]):
              this.$set(this.model, key, Number(query[key]));
              break;
            default:
              this.$set(this.model, key, query[key]);
          }
        }
      }

      (async () => {
        if (this.$store.getters.getLocation !== null) return;

        if (this.$route.query.location) {
          this.$store.commit("setLocation", this.$route.query.location);
          return;
        }

        this.$store.commit("setLocation", FILTER.location);

        let vm = this,
          geocoder = new google.maps.Geocoder();

        if (vm.$route.query.address !== undefined)
          await geocoder.geocode(
            { address: this.$route.query.address },
            await function (results, status) {
              if (results === null) return; //must use geocoder api key
              vm.$store.commit("setLocation", {
                address: vm.$route.query.address,
                latlng:
                  results[0].geometry.location.lat() +
                  "," +
                  results[0].geometry.location.lng(),
              });
            }
          );
      })().then(() => {
        if (this.$store.getters.getLocation === null)
          this.$store.commit("setLocation", FILTER.location);

        this.$set(this.model, "location", this.$store.getters.getLocation);
        this.$set(this.model, "category", this.$route.params.id);

        if (typeof this.model.distance === "undefined")
          this.$set(this.model, "distance", 35);
      });
    },
    startWatch() {
      this.$watch(
        "model",
        debounce(() => {
          this.submit();
        }, 1000),
        {
          deep: true,
        }
      );
    },

    reset() {
      this.model = FILTER;
      this.model.tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.resetModel(this.model);
    },

    submit() {
      this.$emit("submit", this.model);
    },

    hydrateFields(fields) {
      // First time field should be set as is
      if (!this.fields.all().length) {
        this.setFields(fields);
        return;
      }

      // Otherwise hydrate some field configs
      // omitting current value
      fieldsHydrator(this.fields, fields);
    },

    saveSearch(sender /* SearchTitleModal */, data) {
      this.$http
        .post("searches", {
          params: this.model,
          name: data.name,
        })
        .then(() => {
          sender.hide();
          this.$toast.success(this.$t("Search is saved"));
        })
        .catch((err) => {
          const status = err.response.status;
          if (status === 402) {
            window.location.href = `/account#/payment/${err.response.data.data.id}/search-adds`;
          }
        });
    },

    onModalSubmit(sender /* BestAddModal */, model) {
      this.$http
        .post("searches/best-companies", {
          params: Object.assign({}, this.model),
          ...model,
        })
        .then(() => {
          sender.hide();
          this.$toast.success(this.$t("Best Ads is saved"));
        })
        .catch((err) => {
          const status = err.response.status;
          if (status === 402) {
            window.location.href = `/account#/payment/${err.response.data.data.id}/best-adds`;
          }
        });
    },

    onBestAdButtonClickSubmit() {
      const authorized = $('meta[name="auth-token"]').attr("content");
      if (authorized) {
        this.$refs.modal.show();
      } else {
        window.location.href = "/login";
      }
    },

    async onPriceRequestClick() {
      if (!this.isUserLoggedIn()) {
        this.$alert.warning("Please log in for price request");
        return;
      }

      if (FORM !== null && FORM.length !== 0) {
        this.$refs.formModal.show();
        return;
      }

      const result = await this.$alert.info(
        "Enter your price request message",
        "",
        {
          type: null,
          input: "textarea",
          showCancelButton: true,
        }
      );

      if (result.value) {
        this.$http
          .post("/price-requests", {
            message_text: result.value,
            filter_query: JSON.stringify(this.model),
          })
          .then(() => {
            this.$toast.success(
              "Your request successfully pushed for moderating"
            );
          })
          .catch((error) => {
            this.$toast.error(error.response.message);
          });
      }
    },
    isUserLoggedIn() {
      const el = document.head.querySelector("meta[name=auth-token]");
      return !!el && !!el.getAttribute("content");
    },
    isNumeric(num) {
      if (num === "" || num === null) return false;
      return !isNaN(num);
    },
  },
};
</script>
